export function convertRequestConfig(pubConfig, headers) {
    // Нет поддержки OPTIONS
    const method = pubConfig.method || (pubConfig.body ? 'POST' : 'GET');
    const scheme = pubConfig.uri.scheme || 'https';
    const port = pubConfig.uri.port || (scheme === 'https' ? 443 : 80);
    const withCredentials = typeof pubConfig.withCredentials === 'undefined' || pubConfig.withCredentials;
    const requestType = pubConfig.requestType || 'string';
    const url = new URL(`${scheme}://${pubConfig.uri.host}:${port}${pubConfig.uri.path}${pubConfig.uri.query ? '?' + pubConfig.uri.query : ''}`);
    return {
        method,
        body: pubConfig.body,
        headers,
        withCredentials,
        url,
        // TODO: вычислять, является ли хост внешним/внутренним
        isExternal: false,
        requestType,
    };
}
//# sourceMappingURL=convertRequestConfig.js.map